// TODO - remove lint disable when editing this file
/* eslint-disable */
//
import { ToHTMLConverterMiddleware } from './base'
import { COLOR_STYLE_PREFIX } from '~/redux/customColors'

export class HighlightToHTMLConverterMiddleware extends ToHTMLConverterMiddleware {
  processStyle(content, style, block, context, nextCallback) {
    const colorCode = style.find((aStyle) =>
      aStyle.startsWith(COLOR_STYLE_PREFIX)
    )

    let prefix = ''
    // No color code. Close mark in case it was a color code before and process next styles
    if (!colorCode) {
      prefix = context.colorCode ? '</mark>' : ''
      context.colorCode = null
      return prefix + nextCallback(content, style, block, context)
    }

    // Color has been changed. Close mark and continue
    if (context.colorCode && context.colorCode !== colorCode) {
      context.colorCode = null
      prefix = '</mark>'
    }

    // First occurence of the color or color was changed. Adding <mark class...
    if (!context.colorCode) {
      context.colorCode = colorCode
      const colorClass = colorCode.split(COLOR_STYLE_PREFIX).join('')
      const processedContent = nextCallback(
        content,
        style.subtract([colorCode]),
        block,
        context
      )
      return `${prefix}<mark class="${colorClass}">${processedContent}`
    }

    // We are here if previous and current call has been made with the same color code
    // Continue processing other styles as we are under <mark ... already
    return nextCallback(content, style.subtract([colorCode]), block, context)
  }

  endStyles(content, context, nextCallback) {
    const postfix = context.colorCode ? '</mark>' : ''
    context.colorCode = null
    return nextCallback(content, context) + postfix
  }
}
